import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { type DateRange } from 'react-day-picker';

dayjs.extend(utc);

export const getDateFromAndTo = (date: Date | undefined) => {
  const dateFrom = date ? date.toISOString() : undefined;
  let dateTo: string | undefined;

  if (date) {
    // Clone the original date
    const newDate = new Date(date.getTime());
    // Add one day to the new Date object
    newDate.setDate(newDate.getDate() + 1);
    dateTo = newDate.toISOString();
  }

  return {
    dateFrom,
    dateTo,
  };
};

export const toUTCString = (date: Date | undefined) => {
  if (!date) return;

  const localDate = new Date(date);
  return new Date(
    localDate.getTime() - localDate.getTimezoneOffset() * 60000
  ).toISOString();
};

export const toRangeEndUTCString = (date: Date | undefined) => {
  if (!date) return;

  const localDate = new Date(date);
  const utcDate = new Date(
    localDate.getTime() - localDate.getTimezoneOffset() * 60000
  );
  utcDate.setUTCHours(23, 59, 59, 0);
  return utcDate.toISOString();
};

export const parseUTCString = (value: string) => {
  const date = new Date(value);

  return new Date(date.getTime() + date.getTimezoneOffset() * 60000);
};

export const parseRangeDateFromUrl = (stringifiedDates: unknown): DateRange => {
  const rangeDates = stringifiedDates as Record<keyof DateRange, string>;

  return {
    from: rangeDates.from ? parseUTCString(rangeDates.from) : undefined,
    to: rangeDates.to ? parseUTCString(rangeDates.to) : undefined,
  };
};

export const serializeRangeDateToUrl = (value: DateRange) => {
  return JSON.stringify({
    from: toUTCString(value.from),
    to: toUTCString(value.to),
  });
};
